import { axios } from './client'

export const LOGIN_URL = process.env.REACT_APP_VERACITY_BASE_URL + '/login';

const verifyToken = async () => {
    try {
        return await axios.get(`users/me`).then(response => response.data);
    } catch (error) {
        console.log(error);
        return Promise.reject(error);
    }


}
const logout = async () => {
    let token = localStorage.getItem('token');

    if (!token) {
        return false;
    }
    try {
        await axios.get(`logout/${token}`).then((response) => {
            window.location.href = LOGIN_URL
        })
    } catch (error) {
        console.log(error);
    }
}

export default { verifyToken, logout };


